import { ROLES } from '@/constants/roles';

export const eventModerationList = {
  path: '/events/moderation',
  name: 'events-moderation',
  component: () => import('./views/events-list.vue'),
  meta: {
    title: 'Модерация мероприятий',
    icon: 'mdi-text-box-check-outline',
    accessList: [ROLES.operator, ROLES.department, ROLES.moderator],
    instruction: {
      id: 15,
      name: 'Модерация мероприятий',
    },
  },
};

export const moderatorsList = {
  path: '/moderators',
  name: 'moderators',
  component: () => import('./views/moderators-list.vue'),
  meta: {
    title: 'Модераторы',
    accessList: [ROLES.operator, ROLES.department],
  },
};

export default [eventModerationList, moderatorsList];
